import { useEffect } from 'react';

const useSetNoAuthCard = (arr, pending, func, refetch) => {
  // If no selectors and we are done fetching them (and the refetch isn't fired)
  // set auth sequencing pending to false so that we can render the no available card
  useEffect(() => {
    if (!arr.length && !pending && !refetch) {
      func(false);
    }
  }, [arr, pending, func, refetch]);
};

export default useSetNoAuthCard;
